import { styled } from '@mui/material/styles';
import { Box, Typography, Link } from '@mui/material';

export const FooterContainer = styled('footer')(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  padding: theme.spacing(2, 2),
  marginTop: theme.spacing(4),
  borderTop: `1px solid ${theme.palette.primary.dark || '#1e2f3f'}`,
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5, 2),
  },
}));

export const FooterContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  maxWidth: '1200px',
  margin: '0 auto',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
}));

export const FooterSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  [theme.breakpoints.down('sm')]: {
    alignItems: 'center',
    textAlign: 'center',
  },
}));

export const CopyrightText = styled(Typography)(({ theme }) => ({
  fontSize: '0.75rem',
  color: theme.palette.primary.contrastText || '#ffffff',
  fontStyle: 'normal',
}));

export const SocialLinksContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.5),
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
}));

export const SocialLink = styled(Link)(({ theme }) => ({
  fontSize: '0.75rem',
  color: theme.palette.primary.contrastText || '#ffffff',
  textDecoration: 'none',
  opacity: 0.9,
  '&:hover': {
    opacity: 1,
    textDecoration: 'underline',
  },
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary.contrastText || '#ffffff'}`,
    outlineOffset: '2px',
    borderRadius: '2px',
  },
}));

export const AimScoreContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.25),
  maxWidth: '250px',
  [theme.breakpoints.down('sm')]: {
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: '100%',
  },
}));

export const AimScoreText = styled(Typography)(({ theme }) => ({
  fontSize: '0.75rem',
  color: theme.palette.primary.contrastText || '#ffffff',
  fontStyle: 'normal',
}));

export const AimScoreLink = styled(Link)(({ theme }) => ({
  fontSize: '0.7rem',
  color: theme.palette.primary.contrastText || '#ffffff',
  textDecoration: 'none',
  opacity: 0.9,
  '&:hover': {
    opacity: 1,
    textDecoration: 'underline',
  },
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary.contrastText || '#ffffff'}`,
    outlineOffset: '2px',
    borderRadius: '2px',
  },
}));
